var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _path, _circle2, _path2, _circle3, _path3, _circle4, _path4, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle5, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCitraAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 560,
    viewBox: "0 0 900 560",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 560,
    rx: 18,
    fill: "#F9F9F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 72,
    width: 760,
    height: 416,
    rx: 18,
    fill: "#FFFFFF",
    stroke: "#E7E9EE",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 124,
    width: 220,
    height: 116,
    rx: 14,
    fill: "#161C2D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 280,
    width: 220,
    height: 116,
    rx: 14,
    fill: "#FFFFFF",
    stroke: "#E7E9EE",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 124,
    width: 220,
    height: 116,
    rx: 14,
    fill: "#FFFFFF",
    stroke: "#E7E9EE",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 280,
    width: 220,
    height: 116,
    rx: 14,
    fill: "#161C2D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 182,
    r: 28,
    fill: "#F7C242"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165 183L173 191L191 170",
    stroke: "#161C2D",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 338,
    r: 28,
    fill: "#00B295"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165 339L173 347L191 326",
    stroke: "#FFFFFF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 618,
    cy: 182,
    r: 28,
    fill: "#57B8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M607 183L615 191L633 170",
    stroke: "#FFFFFF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 618,
    cy: 338,
    r: 28,
    fill: "#F7C242"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M607 339L615 347L633 326",
    stroke: "#161C2D",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 160,
    width: 98,
    height: 12,
    rx: 6,
    fill: "#FFFFFF",
    opacity: 0.9
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 187,
    width: 72,
    height: 10,
    rx: 5,
    fill: "#FFFFFF",
    opacity: 0.45
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 316,
    width: 98,
    height: 12,
    rx: 6,
    fill: "#161C2D",
    opacity: 0.9
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 343,
    width: 72,
    height: 10,
    rx: 5,
    fill: "#8492A6",
    opacity: 0.7
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 652,
    y: 160,
    width: 98,
    height: 12,
    rx: 6,
    fill: "#161C2D",
    opacity: 0.9
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 652,
    y: 187,
    width: 72,
    height: 10,
    rx: 5,
    fill: "#8492A6",
    opacity: 0.7
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 652,
    y: 316,
    width: 98,
    height: 12,
    rx: 6,
    fill: "#FFFFFF",
    opacity: 0.9
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 652,
    y: 343,
    width: 72,
    height: 10,
    rx: 5,
    fill: "#FFFFFF",
    opacity: 0.45
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M360 182H510",
    stroke: "#F7C242",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M496 166L522 182L496 198",
    stroke: "#F7C242",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M670 258V244C670 226 655 211 637 211H618",
    stroke: "#57B8FF",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M644 258L670 286L696 258",
    stroke: "#57B8FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M540 338H390",
    stroke: "#00B295",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M404 322L378 338L404 354",
    stroke: "#00B295",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M228 258V244C228 226 243 211 261 211H286",
    stroke: "#8492A6",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M202 258L228 286L254 258",
    stroke: "#8492A6",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 278,
    r: 64,
    fill: "#FFFFFF",
    stroke: "#E7E9EE",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M420 274L444 298L488 250",
    stroke: "#F7C242",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M450 212V192",
    stroke: "#00B295",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M450 364V344",
    stroke: "#00B295",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M514 278H534",
    stroke: "#57B8FF",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M366 278H386",
    stroke: "#57B8FF",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitraAccess);
export default __webpack_public_path__ + "static/media/citra-access.ab08fa8e5aa080162e17002504621484.svg";
export { ForwardRef as ReactComponent };